<template>
		<el-popover
				placement="bottom"
				width="400"
				v-model="visable[column.property]"
				trigger="manual">
				<table-pagination
					:data="tableData"
					:column="comonColumn"
					pagination
					layout="prev,pager,next,total"
					:total="total"
					:page.sync="listQuery.pageNumber"
					:limit.sync="listQuery.pageSize"
					v-loading="loading"
					@pagination="getList"
					 v-outside="closeBox"
					ref="tableItem">
				</table-pagination>
				<el-button slot="reference" type="text" @click="toShowDetail">{{row[column.property]}}</el-button>
			</el-popover>
</template>

<script>
	import {day_data} from '../data.js'
	export default {
		props: ['row', 'column'],
		data(){
			return {
				visable:{
					holidayCount:false,
					workdayCount:false,
					specialCount:false
				},
				listQuery:{
					brand:this.$store.state.user.brandId,
					pageNumber:1,
					pageSize:10,
					skillgroup:''
				},
				total:0,
				loading:false,
				tableData:[],
				comonColumn:[
					{
						label: "日期", 
						prop: "beginTime",
						width:220,
						render: (h, scope) => {
							return <span>{this.formatDate(scope.row)}</span>
						 }
					},{
						label:'工作时间',
						prop:'endTime',
						width:150,
						render: (h,scope) => {
							return <span>{this.formatTime(scope.row)}</span>
						}
					}
				]
			}
		},
		methods:{
			getList(){
				this.listQuery.skillgroup = this.row.skillGroup;
				switch(this.column.property){
					case 'workdayCount':
						this.getWorkDayList();
						break;
					case 'holidayCount':
					case 'specialCount':
						this.getHolidayList();
						break;
				}
			},
			getWorkDayList(){
				this.loading = true;
				this.$api.apiGetWorkdayListForSystem(this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.tableData = res.data;
					this.total = Number(res.total);

				})
			},
			getHolidayList(){
				this.loading = true;
				let params = JSON.parse(JSON.stringify(this.listQuery));
				params.holidayType = this.column.property == 'holidayCount' ? '0' : '1';
				this.$api.apiGetHolidayListForSystem(params).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.tableData = res.data;
					this.total = Number(res.total);
				})
			},
			toShowDetail(){
				this.visable[this.column.property] = !this.visable[this.column.property];
				if(!this.visable[this.column.property]) return;
				this.listQuery.pageNumber = 1;
				this.getList();
			},
			closeBox(){
				this.visable[this.column.property] = false;
			},
			formatDate(row){
				let result = [];
				const weekData = ['周日','周一','周二','周三','周四','周五','周六'];
				if(this.column.property == 'workdayCount'){
					let catchtArr = row.workdayWeek.split('|');
					let resultList = [];
					catchtArr.map((item,index) => {
						if(item == 1){
							resultList.push(weekData[index])
						}
					})
					if(resultList.length >= 7) return '每天';
					return resultList.length > 0 ? resultList.join(',') : '暂无'
				}
				return this.$dayjs(row.beginTime).format('YYYY-MM-DD') + '至' + this.$dayjs(row.endTime).format('YYYY-MM-DD')
				
			},
			formatTime(row){
				if(this.column.property == 'workdayCount') return row.beginTime + '至' + row.endTime;
				return this.$dayjs(row.beginTime).format('HH:mm') + '至' + this.$dayjs(row.endTime).format('HH:mm')
				
			}
			
		},
		
	}
</script>

<style>
</style>
